import React, { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { oneGraphClient } from '../../constants/environment';
import { VEHICLE_BY_AUDICODE } from '../../schemas/VehicleByAudiCode';

const useFetchByAudiCode = (audiCode: string | null) => {
  const { loading, data, error } = useQuery(VEHICLE_BY_AUDICODE, {
    fetchPolicy: 'no-cache',
    client: oneGraphClient,
    skip: !audiCode,
    variables: {
      code: audiCode,
      filterInput: {
        filterByProfileId: 'ngccfront34desktopenv1s',
      },
    },
  });

  const vehicleAudiCodeDetails = useMemo(() => {
    if (!data) return undefined;
    return {
      modelName: data?.carByCode.carline.name,
      modelYear: data?.carByCode.model.id.year,
      trimName: data?.carByCode.model.name,
      vehicleMedia: {
        mediaImages: [{ url: data?.carByCode.media?.images[0]?.url }],
      },
    };
  }, [data]);

  return { vehicleAudiCodeDetails, isAudiCodeVehicleLoading: loading };
};

export default useFetchByAudiCode;
